import { z } from 'zod';
import type { MessageDto } from '../types/MessageDto';

export const messageDtoSchema = z.object({
  id: z.string().uuid(),
  text: z.string().min(2).max(255),
  creatorId: z.string().uuid(),
  chatId: z.string().uuid(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  deletedAt: z.string().datetime({ offset: true }).nullable(),
}) as z.ZodType<MessageDto>;
